<template>
    <Navbar></Navbar>
    <div class="page-box">
        <div class="img-box page-banner">
            <img src="/assets/manufacture/engine/xushui/xs.jpg" alt=""></img>
            <div class="title-box">
                <div class="manufacture-t1">
                    变速器徐水工厂
                </div>
                <div class="manufacture-t2">
                    作为第四个发动机生产工厂，位于河北省保定市，公司整体占地6.7万平方米，于2013年9月SOP，有9条生产线体；<br />
                    产品搭载坦克、皮卡、魏品牌高端新能源车型，蓝山、高山、摩卡车型，在混动汽车市场热效率属于第一梯队。
                </div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                机加车间
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                产线特点
                            </div>
                            <div class="destils">
                                线体应用U型并联式布局，采用先进的德国GROB双主轴卧式加工中心、德国NAGEL珩磨机、德国勇克磨床、意大利马波斯测量机、日本牧野加工中心与意大利科玛加工中心，工件输送通过双工位桁架机械手和自动辊道完成，配备在线100%测量设备，对部件精密运动副部位进行质量管控，保证产品加工一致性
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/xushui/xs1-1.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination left"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                装试车间
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/xushui/xs2-1.jpg" alt="">
                        </div>
                        <div class="text-box ">
                            <div class="title">
                                产线特点
                            </div>
                            <div class="destils">
                                采用世界知名AMS生产、ATLAS拧紧管理及MES管理系统，实现生产信息可追溯性，配备冷试及整机视觉检测设备，采用等离子清洁技术保证涂胶密封性，线体通过视觉技术等实现工位防错覆盖率100%，保证装机一致性及出厂质量
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

        <div class="page-title-box">
            <div class="page-t1">
                质量保障
            </div>
        </div>

        <div class="page-sw">
            <div class="swiper-container kv-container swiper-item">
                <div class="swiper-wrapper">
                    <div class="swiper-slide">
                        
                        <div class="text-box ">
                            <div class="title">
                                质量保障
                            </div>
                            <div class="destils">
                                公司配备高精尖测量设备，精密测量室为恒温、恒湿无尘实验室，引进国际高端检测设备，配置有：德国蔡司三坐标4台，日本东京精密圆度仪1台，日本东京精密粗糙度轮廓仪1台，德国霍梅尔综合测量机1台，可依据工艺要求，对各种机型的缸体、缸盖、曲轴自制件，
                                以及众多外协件实施精密测量，且设备具有扫码存储功能，将零件信息与检测信息自动绑定，能够实现生产过程质量精准追溯，提升加工过程能力，保证产品质量稳定性%，保证装机一致性及出厂质量
                            </div>
                        </div>
                        <div class="img-box">
                            <img src="/assets/manufacture/engine/xushui/xs3-1.jpg" alt="">
                        </div>
                    </div>
                </div>
                <div class="kv_pagination swiper-pagination"></div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import $ from 'jquery';

// 存储所有swiper实例，方便销毁
const swiperInstances = ref([]);

// 初始化所有轮播的核心函数
const initAllSwipers = async () => {
    await nextTick();

    const swiperElements = document.querySelectorAll('.swiper-item');

    swiperElements.forEach(el => {
        if (el) {
            const swiper = new Swiper(el, {
                speed: 1300,
                pagination: {
                    el: el.querySelector(".swiper-pagination"), // 绑定当前容器内的分页器
                    clickable: true,
                },
                direction: "horizontal",
                slidesPerView: 1,
                // spaceBetween: 20,
                simulateTouch: true,
                effect: 'fade',
                breakpoints: {
                    768: {},
                    1024: {}
                },
                // navigation: {
                //     nextEl: el.querySelector(".btn-r"),
                //     prevEl: el.querySelector(".btn-l"),
                //     disabledClass: 'swiper-button-disabled',
                // },
                on: {
                    // init: function () {
                    //     console.log('轮播初始化完成');
                    // },
                    // slideChangeTransitionStart(swiper) {
                    //     let swiperIndex = swiper.realIndex;
                    //     console.log('当前轮播索引：', swiperIndex);
                    // },
                },
            });
            swiperInstances.value.push(swiper); // 保存实例
        }
    });
};

// 页面挂载时初始化轮播
onMounted(() => {
    initAllSwipers();
});

// 页面卸载时销毁轮播实例（防止内存泄漏）
onUnmounted(() => {
    swiperInstances.value.forEach(swiper => {
        swiper.destroy(true, true);
    });
    swiperInstances.value = [];
});
</script>

<script>
export const pageConfig = {
    title: '变速器徐水工厂 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'manufacture/en/xushui.html'
};

import { createApp } from 'vue';
import App from './xushui.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/manufacture-detail.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./xushui.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss"></style>
